<template>
	<div class="features-settings">
		<CardSlashed v-if="userStore?.bannersData && !userStore?.bannersData?.has_qr_orders" class="card-info-banner">
			<template #left>
				<div class="card-info-banner-title divider">
					<h2>{{ getString('card_info_title_1_oep') }}</h2>
					<p>{{ getString('card_info_description_1_oep') }}</p>
					<a target="_blank" href="https://qromo-help.freshdesk.com/support/solutions/articles/202000100919-ordina-e-paga" class="icon-link">
						{{ getString('card_info_cta_1_oep') }}
						<div class="wrapper-icon">
							<img src="https://img.qromo.io/img/icon-arrow-link-banner-geen.svg" alt="console icon">
						</div>
					</a>
				</div>
				<div class="card-info-banner-title">
					<h2>{{ getString('card_info_title_2_oep') }}</h2>
					<p>{{ getString('card_info_description_2_oep') }}</p>
					<a target="_blank" href="https://qromo-help.freshdesk.com/support/solutions/articles/202000098836-come-funziona-il-servizio-paga-il-conto-" class="icon-link">
						{{ getString('card_info_cta_2_oep') }}
						<div class="wrapper-icon">
							<img src="https://img.qromo.io/img/icon-arrow-link-banner-geen.svg" alt="console icon">
						</div>
					</a>
				</div>
			</template>
			<template #right>
				<div class="wrapper-img">
					<picture>
						<source type="image/webp" srcset="https://img.qromo.io/img/image-info-banner-oep.webp">
						<img src="https://img.qromo.io/img/image-info-banner-oep.png" alt="product image">
					</picture>
				</div>
			</template>
		</CardSlashed>
		<AppCard :title="getString('order_features')" :button-text="getString('save')" @button-click="saveOrderFeatures">
			<template v-slot:body>
				<AppList :items="this.items">
					<template v-slot:dropdown-list-slot="{item}">
						<div class="dropdown-list">
							<AppList :items="item.itemChildren" >
								<template v-slot:quantity-slot="{item}">
									<div class="row space-between quantity-container">
										<p>{{ item.title }}</p>
										<AppNumberInput class="ml-auto" :symbol="item.symbol" :right-side-symbol="item.rightSideSymbol" :double-decimal="item.doubleDecimal" :value="item.value" :min="item.min" :max="item.max" @changed-value="item.changedValue" />
									</div>
								</template>
							</AppList>
						</div>
					</template>
					<template v-slot:quantity-slot="{item}">
						<div class="row flex-end">
							<AppNumberInput :label="item.label" :symbol="item.symbol" :right-side-symbol="item.rightSideSymbol" :double-decimal="item.doubleDecimal" :value="item.value" :min="item.min" :max="item.max" @changed-value="item.changedValue" />
						</div>
					</template>
				</AppList>
			</template>
		</AppCard>
		<AppCard class="card-margin" :title="getString('marketing')" :button-text="getString('save')" @button-click="saveMarketing">
			<template v-slot:body>
				<AppList :items="this.itemsMarketing">
                    <template v-slot:dropdown-list-slot="{item}">
                        <div class="dropdown-list">
                            <AppList :items="item.itemChildren" >
                                <template v-slot:quantity-slot="{item}">
                                    <div class="row space-between quantity-container">
                                        <p>{{ item.title }}</p>
                                        <AppNumberInput class="ml-auto" :symbol="item.symbol" :right-side-symbol="item.rightSideSymbol" :double-decimal="item.doubleDecimal" :value="item.value" :min="item.min" :max="item.max" @changed-value="item.changedValue" />
                                    </div>
                                </template>
								<template #ref-link-slot="{item}">
									<div class="row flex-end">
										<AppTextInput :value="item.value" :type="item.type" :placeholder="getString('link_placeholder')" @changed-text="item.changedText"/>
									</div>
								</template>
								<template v-slot:dropdown-list-slot="{item}">
									<div class="dropdown-list">
										<AppList :items="item.itemChildren" />
									</div>
								</template>
								<template #analytics-switch-header="{item}">
									<div class="list-item-header">
										<p class="list-item-title">{{ item.title }}</p>
										<AppSwitch class="right-item" :checked="item.switchChecked" @switched="item.switchCallback" />
									</div>
								</template>
                            </AppList>
                        </div>
                    </template>
					<template #custom-terms>
						<div class="row flex-end">
							<AppTextInput :label="getString('link')" :placeholder="getString('link_placeholder')" :value="userStore.currBusiness && userStore.currBusiness.custom_terms ? userStore.currBusiness.custom_terms : ''" @changed-text="(value) => userStore.currBusiness.custom_terms = value" />
						</div>
					</template>
				</AppList>
			</template>
		</AppCard>
		<AppCard class="card-margin" :title="getString('order_completion')" :button-text="getString('save')" @button-click="saveOrderCompletion">
			<template v-slot:body>
				<AppList :items="this.itemsCompletion">
					<template v-slot:list-slot="{item}">
						<div class="row list-slot-container">
							<AppList :items="item.subitems" >
								<template #mode-slot>
									<div class="completable-options">
										<div class="extra-text">
											<p>{{ getString("customer_completable_order_modes") }}</p>
										</div>
										<AppRadioButtonGroup :selected="selectedCustomerOrderModeIndex()" :title="getString('modes')" :values="['QR', 'Tap']" @radio-chosen="orderCustomerConfRadioChosen" />
									</div>
								</template>
								<template #colors-gradient="{item}">
									<div class="row colors-gradient-container">
										<p>{{ getString('ticket_animation_colors') }}</p>
										<div class="colors-gradient">
											<AppColorPicker :value="item.color1" @changed-color="color => item.colorCallback(1, color)" />
											<AppColorPicker :value="item.color2" @changed-color="color => item.colorCallback(2, color)" />
											<AppColorPicker :value="item.color3" @changed-color="color => item.colorCallback(3, color)" />
										</div>
									</div>
								</template>
							</AppList>
						</div>
					</template>
				</AppList>
			</template>
		</AppCard>
	</div>
</template>

<script>
import AppList from "@/shared/components/AppList.vue";
import AppCard from "@/shared/components/AppCard.vue";
import AppRadioButtonGroup from "@/shared/components/AppRadioButtonGroup.vue";
import AppNumberInput from "@/shared/components/AppNumberInput.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppDropdown from "@/shared/components/AppDropdown.vue";
import AppSwitch from "@/shared/components/AppSwitch.vue";
import CardSlashed from "@/console-new/components/shared/CardSlashed.vue";

import {useCurrencyStore, useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
import {validateLink} from "@/shared/helpers/strings";
import AppColorPicker from "@/shared/components/AppColorPicker.vue";
import API from '@/shared/helpers/API.js';

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		const notificationStore = useNotificationStore();
		const currencyStore = useCurrencyStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, currencyStore, userStore}
	},
	name: "FeaturesSettingsContainer",
	components: {
		AppColorPicker,
		AppSwitch,
		AppDropdown, AppChevronIcon, AppTextInput, AppNumberInput, AppRadioButtonGroup, AppList, AppCard, CardSlashed},
	data() {
		return {
			legalActive: false,
			analyticsActive: false,
			ga4SwitchActive: false,
			metaSwitchActive: false,
			tiktokSwitchActive: false,
			adsSwitchActive: false,
		}
	},
	computed: {
		items() {
			return [
				{
					title: this.getString("order_minimum"),
					switch: true,
					active: this.userStore.currBusiness && this.userStore.currBusiness.min_order !== null,
					min: 0,
					max: null,
					dropdownSlot: "quantity-slot",
					callback: (active) => {
						this.userStore.currBusiness.min_order = active ? this.currencyStore.currMinInteger : null
					},
					label: this.getString("order_minimum_x", [this.currencyStore.currCurrency.symbol]),
					value: this.userStore.currBusiness && this.userStore.currBusiness.min_order !== null ? this.currencyStore.dbToActualValue(this.userStore.currBusiness.min_order) : 0,
					changedValue: this.changedValueMinOrder,
					doubleDecimal: true
				},
				{title: this.getString("customer_notes"), switch: true, explain: this.getString("customer_notes_explain"), active: this.userStore.currBusiness && !this.userStore.currBusiness.hide_notes, callback: (active) => {this.userStore.currBusiness.hide_notes = !active}},
				{title: this.getString("queue_order"), switch: true, explain: this.getString("queue_order_explain"), active: this.queueActive, callback: this.toggleQueue, dropdownSlot: 'dropdown-list-slot', itemChildren: [
					{title: this.getString("queue_order_menu", [this.userStore.menuWord]), switch: true, active: this.userStore.currBusiness && this.userStore.currBusiness.queue_active_menu, callback: (active) => {this.userStore.currBusiness.queue_active_menu = active}},
					{title: this.getString("queue_active_summary"), switch: true, active: this.userStore.currBusiness && this.userStore.currBusiness.queue_active_summary, callback: (active) => {this.userStore.currBusiness.queue_active_summary = active}},
				]},
                {title: this.getString("orders_buffering"), switch: true, explain: this.getString("orders_buffering_explain"), active: this.userStore.currBusiness && this.userStore.currBusiness.buffer_time !== null, callback: this.toggleBufferTime, dropdownSlot: 'dropdown-list-slot', itemChildren: [
                    {title: this.getString("buffer_time"), min: 30, max: 600, numberInput: true, value: this.userStore.currBusiness && this.userStore.currBusiness.buffer_time !== null ? this.userStore.currBusiness.buffer_time : 300, callbackNumber: this.changedValueBufferTime, symbol: "s", rightSymbol: true},
                    {title: this.getString("user_controlled"), explain: this.getString("user_controlled_explain"), switch: true, active: this.userStore.currBusiness && this.userStore.currBusiness.buffer_customers, callback: (active) => {this.userStore.currBusiness.buffer_customers = active}},
                ]},
				{title: this.getString("preparing_time"), switch: true, active: this.userStore.currBusiness && this.userStore.currBusiness.preparation_time !== null, min: 0, max: null, dropdownSlot: "quantity-slot", callback: this.switchPreparingTime, value: this.userStore.currBusiness && this.userStore.currBusiness.preparation_time !== null ? this.userStore.currBusiness.preparation_time : 30, changedValue: this.changedValuePreparationTime, symbol: "m", rightSideSymbol: true},
			];
		},
        itemsMarketing() {
            return [
                {title: this.getString("coupon_codes"), switch: true, active: this.userStore.currBusiness && this.userStore.currBusiness.coupons, callback: (active) => {this.userStore.currBusiness.coupons = active}},
				{
					title: this.getString("cross_selling"),
					switch: true,
					explain: this.getString("cross_selling_explain"),
					active: this.userStore.currBusiness && (this.userStore.currBusiness.cross_selling || this.userStore.currBusiness.cross_selling_popup),
					callback: this.toggleCrossSelling,
					dropdownSlot: 'dropdown-list-slot',
					itemChildren: [
						{
							title: this.getString("cross_order_summary"),
							explain: this.getString("cross_order_summary_explain"),
							switch: true,
							active: this.userStore.currBusiness && this.userStore.currBusiness.cross_selling,
							callback: (active) => {
								this.userStore.currBusiness.cross_selling = active
							}
						},
						{
							title: this.getString("cross_force_popup"),
							explain: this.getString("cross_force_popup_explain"),
							switch: true,
							active: this.userStore.currBusiness && this.userStore.currBusiness.cross_selling_popup,
							callback: (active) => {
								this.userStore.currBusiness.cross_selling_popup = active
							}
						},
					]
				},
				{
					title: this.getString("feedbacks"),
					switch: true,
					explain: this.getString("feedbacks_explain"),
					active: this.feedbacksActive,
					callback: this.toggleFeedbacks,
					dropdownSlot: 'dropdown-list-slot',
					itemChildren: [
						{
							title: this.getString("public_feedbacks", [this.userStore.menuWord]),
							switch: true,
							active: this.userStore.currBusiness && !this.userStore.currBusiness.private_feedbacks,
							callback: (active) => {
								this.userStore.currBusiness.private_feedbacks = !active
							}
						},
						{
							title: this.getString("link_feedbacks_title"),
							explain: this.getString("link_feedbacks_explain"),
							switch: true,
							active: this.linkFeedbacksToggleValue,
							callback: (active) => {
								if(!active)
									this.userStore.currBusiness.link_feedbacks = null;
							},
							dropdownSlot: 'ref-link-slot',
							value: this.linkFeedbacksToggleValue ? this.userStore.currBusiness.link_feedbacks : "",
							type: 'url',
							changedText: (link) => this.userStore.currBusiness.link_feedbacks = link
						}
					]
				},
				{title: this.getString("cash_payments_ask_email"), switch: true, explain: this.getString("cash_payments_ask_email_explain"), active: this.userStore.currBusiness && this.userStore.currBusiness.enabled_box_email_cash, callback: (active) => {this.userStore.currBusiness.enabled_box_email_cash = active}},
				{title: this.getString("require_privacy"), switch: true, explain: this.getString("require_privacy_explain"), active: this.userStore.currBusiness && this.userStore.currBusiness.force_privacy, callback: (active) => {this.userStore.currBusiness.force_privacy = active}},
				{title: this.getString("custom_legal_contracts"), chevronItem: true, active: this.legalActive, dropdownSlot: 'dropdown-list-slot', callback: (active) => {
						this.legalActive = active;
				}, itemChildren: [
					{title: this.getString("custom_terms"), explain: this.getString("custom_terms_explain"), textInput: true, placeholder: this.getString("link_placeholder"), value: this.userStore.currBusiness && this.userStore.currBusiness.custom_terms ? this.userStore.currBusiness.custom_terms : '', callbackText: v => {this.userStore.currBusiness.custom_terms = v }},
					{title: this.getString("custom_privacy"), explain: this.getString("custom_privacy_explain"), textInput: true, placeholder: this.getString("link_placeholder"), value: this.userStore.currBusiness && this.userStore.currBusiness.custom_privacy ? this.userStore.currBusiness.custom_privacy : '', callbackText: v => {this.userStore.currBusiness.custom_privacy = v }},
				]},
				{title: this.getString("bring_own_analytics"), chevronItem: true, active: this.analyticsActive, explain: this.getString("bring_own_analytics_explain", [this.userStore.menuWord]), dropdownSlot: 'dropdown-list-slot', callback: (active) => {
						this.analyticsActive = active;
				}, itemChildren: [
					{
						title: "Google Analytics 4",
						customSlot: 'analytics-switch-header',
						switchChecked: this.ga4SwitchActive,
						switchCallback: this.toggleGA4,
						active: this.ga4SwitchActive,
						dropdownSlot: 'dropdown-list-slot',
						itemChildren: [
							{title: this.getString("ga4_tag_id"), textInput: true, placeholder: this.getString("ga4_tag_placeholder"), value: this.userStore.currBusiness && this.userStore.currBusiness.analytics_ga4_id ? this.userStore.currBusiness.analytics_ga4_id : '', callbackText: v => {this.userStore.currBusiness.analytics_ga4_id = v }},
						]
					},
					{
						title: "Google Ads",
						customSlot: 'analytics-switch-header',
						switchChecked: this.adsSwitchActive,
						switchCallback: this.toggleAds,
						active: this.adsSwitchActive,
						dropdownSlot: 'dropdown-list-slot',
						itemChildren: [
							{title: this.getString("ads_id"), textInput: true, placeholder: this.getString("ads_id_placeholder"), value: this.userStore.currBusiness && this.userStore.currBusiness.analytics_ads_id ? this.userStore.currBusiness.analytics_ads_id : '', callbackText: v => {this.userStore.currBusiness.analytics_ads_id = v }},
							{title: this.getString("ads_purchase_label"), textInput: true, placeholder: this.getString("ads_purchase_label_placeholder"), value: this.userStore.currBusiness && this.userStore.currBusiness.analytics_ads_purchase_label ? this.userStore.currBusiness.analytics_ads_purchase_label : '', callbackText: v => {this.userStore.currBusiness.analytics_ads_purchase_label = v }},
						]
					},
					{
						title: "Meta (Facebook Pixel)",
						customSlot: 'analytics-switch-header',
						switchChecked: this.metaSwitchActive,
						switchCallback: this.toggleMeta,
						active: this.metaSwitchActive,
						dropdownSlot: 'dropdown-list-slot',
						itemChildren: [
							{title: this.getString("meta_pixel_id"), textInput: true, placeholder: this.getString("meta_pixel_placeholder"), value: this.userStore.currBusiness && this.userStore.currBusiness.analytics_meta_pixel_id ? this.userStore.currBusiness.analytics_meta_pixel_id : '', callbackText: v => {this.userStore.currBusiness.analytics_meta_pixel_id = v }},
							{title: this.getString("meta_conversions_key"), textInput: true, inputType: 'password', placeholder: this.getString("meta_conversions_key_placeholder"), value: this.userStore.currBusiness && this.userStore.currBusiness.analytics_meta_conversions_key ? this.userStore.currBusiness.analytics_meta_conversions_key : '', callbackText: v => {this.userStore.currBusiness.analytics_meta_conversions_key = v }},
						]
					},
					{
						title: "TikTok Pixel",
						customSlot: 'analytics-switch-header',
						switchChecked: this.tiktokSwitchActive,
						switchCallback: this.toggleTikTok,
						active: this.tiktokSwitchActive,
						dropdownSlot: 'dropdown-list-slot',
						itemChildren: [
							{title: this.getString("tiktok_pixel_id"), textInput: true, placeholder: this.getString("tiktok_pixel_placeholder"), value: this.userStore.currBusiness && this.userStore.currBusiness.analytics_tiktok_pixel_id ? this.userStore.currBusiness.analytics_tiktok_pixel_id : '', callbackText: v => {this.userStore.currBusiness.analytics_tiktok_pixel_id = v }},
							{title: this.getString("tiktok_access_token"), textInput: true, inputType: 'password', placeholder: this.getString("tiktok_access_token_placeholder"), value: this.userStore.currBusiness && this.userStore.currBusiness.analytics_tiktok_access_token ? this.userStore.currBusiness.analytics_tiktok_access_token : '', callbackText: v => {this.userStore.currBusiness.analytics_tiktok_access_token = v }},
						]
					},
				]},
            ];
        },
		linkFeedbacksToggleValue() {
			return this.userStore.currBusiness &&
			this.userStore.currBusiness.link_feedbacks &&
			this.userStore.currBusiness.link_feedbacks.length > 0
		},
		itemsCompletion() {
			return [
				{title: this.getString("customer_completable_order"), switch: true, active: this.userStore.currBusiness && this.userStore.currBusiness.customer_completable_order > 0, explain: this.getString("customer_completable_order_explain"), dropdownSlot: 'list-slot', callback: this.orderCustomerConfSwitched, subitems: this.subitemsTicketMode},
				{title: this.getString("qr_order_confirmation"), switch: true, active: this.userStore.currBusiness && this.userStore.currBusiness.show_order_qr, explain: this.getString("qr_order_confirmation_explain"), callback: (active) => {this.userStore.currBusiness.show_order_qr = active}},
				{title: this.getString("autocomplete_old_orders"), switch: true, active: this.userStore.currBusiness && this.userStore.currBusiness.autocomplete_old_orders, explain: this.getString("autocomplete_old_orders_explain"), callback: (active) => {this.userStore.currBusiness.autocomplete_old_orders = active}},
				{title: this.getString("allow_request_invoice"), switch: true, active: this.userStore.currBusiness && this.userStore.currBusiness.allow_request_invoice, explain: this.getString("allow_request_invoice_explain"), callback: (active) => {this.userStore.currBusiness.allow_request_invoice = active}},
				{title: this.getString("receipt_background_color"), colorPicker: true, color: this.userStore.currBusiness && this.userStore.currBusiness.receipt_background_color, callbackColor: (color) => {this.userStore.currBusiness.receipt_background_color = color}},
				{title: this.getString("receipt_custom_instructions"), textInput: true, isTextArea: true, placeholder: this.getString("receipt_custom_instructions_placeholder"), value: this.userStore.currBusiness && this.userStore.currBusiness.receipt_custom_instructions ? this.userStore.currBusiness.receipt_custom_instructions : '', callbackText: (value) => {
					this.userStore.currBusiness.receipt_custom_instructions = value.length > 0 ? value : null
				}},
			];
		},
		subitemsTicketMode() {
			return [
				{title: '', customSlot: 'mode-slot'},
				{title: this.getString('ticket_image'), imageSlot: true, image: this.userStore.currBusiness && this.userStore.currBusiness.receipt_ticket_image ? this.userStore.currBusiness.receipt_ticket_image : null, maxBytes: 1024 * 100, maxWidth: 300, maxHeight: 300, callbackImage: (file) => {
						this.userStore.currBusiness.receipt_ticket_image = file;
					}, callbackRemove: () => {
						this.userStore.currBusiness.receipt_ticket_image = null;
					}}, {title: '', customSlot: "colors-gradient", color1: this.userStore.currBusiness && this.userStore.currBusiness.receipt_ticket_color1 ? this.userStore.currBusiness.receipt_ticket_color1 : '2CECBE', color2: this.userStore.currBusiness && this.userStore.currBusiness.receipt_ticket_color2 ? this.userStore.currBusiness.receipt_ticket_color2 : 'FDDE00', color3: this.userStore.currBusiness && this.userStore.currBusiness.receipt_ticket_color3 ? this.userStore.currBusiness.receipt_ticket_color3 : 'FC2291', colorCallback: (index, color) => {
						if (index === 1) {
							this.userStore.currBusiness.receipt_ticket_color1 = color.replace("#", "");
						} else if (index === 2) {
							this.userStore.currBusiness.receipt_ticket_color2 = color.replace("#", "");
						} else if (index === 3) {
							this.userStore.currBusiness.receipt_ticket_color3 = color.replace("#", "");
						}
					}},
			];
		},
		queueActive() {
			return this.userStore.currBusiness && (this.userStore.currBusiness.queue_active_menu || this.userStore.currBusiness.queue_active_summary);
		},
		feedbacksActive() {
			return this.userStore.currBusiness && !this.userStore.currBusiness.disable_feedbacks;
		},
		ga4Active() {
			return this.userStore.currBusiness && this.userStore.currBusiness.analytics_ga4_id && this.userStore.currBusiness.analytics_ga4_id.length > 0;
		},
		metaActive() {
			return this.userStore.currBusiness && this.userStore.currBusiness.analytics_meta_pixel_id && this.userStore.currBusiness.analytics_meta_pixel_id.length > 0;
		},
		tiktokActive() {
			return this.userStore.currBusiness && this.userStore.currBusiness.analytics_tiktok_pixel_id && this.userStore.currBusiness.analytics_tiktok_pixel_id.length > 0;
		},
		adsActive() {
			return this.userStore.currBusiness && this.userStore.currBusiness.analytics_ads_id && this.userStore.currBusiness.analytics_ads_id.length > 0;
		},
		isEnterprise() {
			return this.userStore.currBusiness && this.userStore.currBusiness.active_plan === "enterprise";
		},
		isAllinone() {
			return this.userStore.currBusiness && this.userStore.currBusiness.active_plan === "allinone";
		},
		hasRequiredPlan() {
			return this.isEnterprise || this.isAllinone;
		},
		activeIntegrationsCount() {
			if (!this.userStore.currBusiness) return 0;
			let count = 0;
			if (this.ga4SwitchActive) count++;
			if (this.metaSwitchActive) count++;
			if (this.tiktokSwitchActive) count++;
			if (this.adsSwitchActive) count++;
			return count;
		},
	},
	methods: {
		switchPreparingTime(active) {
			this.userStore.currBusiness.preparation_time = 30;
			if(!active) {
				this.$nextTick(()=>{
					this.userStore.currBusiness.preparation_time = null;
				})
			}
		},
		toggleFeedbacks(active) {
			this.userStore.currBusiness.disable_feedbacks = !active;
			if(active) {
				this.userStore.currBusiness.private_feedbacks = false;
			}
		},
        toggleCrossSelling(active) {
            this.userStore.currBusiness.cross_selling = active;
            this.userStore.currBusiness.cross_selling_popup = false;
        },
		toggleQueue(active) {
			this.userStore.currBusiness.queue_active_menu = active;
			this.userStore.currBusiness.queue_active_summary = active;
		},
		toggleGA4(active) {
			if(active) {
				if (!this.hasRequiredPlan) {
					this.showNotification('byo-analytics-subscription-required');
					this.ga4SwitchActive = true;
					this.$nextTick(() => {
						this.ga4SwitchActive = false;
					});
					return;
				}
				if (this.isAllinone && this.activeIntegrationsCount >= 1) {
					this.showNotification('byo-analytics-multiple-enterprise-required');
					this.ga4SwitchActive = true;
					this.$nextTick(() => {
						this.ga4SwitchActive = false;
					});
					return;
				}
				this.ga4SwitchActive = true;
			} else {
				this.ga4SwitchActive = false;
				this.userStore.currBusiness.analytics_ga4_id = null;
			}
		},
		toggleMeta(active) {
			if(active) {
				if (!this.hasRequiredPlan) {
					this.showNotification('byo-analytics-subscription-required');
					this.metaSwitchActive = true;
					this.$nextTick(() => {
						this.metaSwitchActive = false;
					});
					return;
				}
				if (this.isAllinone && this.activeIntegrationsCount >= 1) {
					this.showNotification('byo-analytics-multiple-enterprise-required');
					this.metaSwitchActive = true;
					this.$nextTick(() => {
						this.metaSwitchActive = false;
					});
					return;
				}
				this.metaSwitchActive = true;
			} else {
				this.metaSwitchActive = false;
				this.userStore.currBusiness.analytics_meta_pixel_id = null;
				this.userStore.currBusiness.analytics_meta_conversions_key = null;
			}
		},
		toggleTikTok(active) {
			if(active) {
				if (!this.hasRequiredPlan) {
					this.showNotification('byo-analytics-subscription-required');
					this.tiktokSwitchActive = true;
					this.$nextTick(() => {
						this.tiktokSwitchActive = false;
					});
					return;
				}
				if (this.isAllinone && this.activeIntegrationsCount >= 1) {
					this.showNotification('byo-analytics-multiple-enterprise-required');
					this.tiktokSwitchActive = true;
					this.$nextTick(() => {
						this.tiktokSwitchActive = false;
					});
					return;
				}
				this.tiktokSwitchActive = true;
			} else {
				this.tiktokSwitchActive = false;
				this.userStore.currBusiness.analytics_tiktok_pixel_id = null;
				this.userStore.currBusiness.analytics_tiktok_access_token = null;
			}
		},
		toggleAds(active) {
			if(active) {
				if (!this.hasRequiredPlan) {
					this.showNotification('byo-analytics-subscription-required');
					this.adsSwitchActive = true;
					this.$nextTick(() => {
						this.adsSwitchActive = false;
					});
					return;
				}
				if (this.isAllinone && this.activeIntegrationsCount >= 1) {
					this.showNotification('byo-analytics-multiple-enterprise-required');
					this.adsSwitchActive = true;
					this.$nextTick(() => {
						this.adsSwitchActive = false;
					});
					return;
				}
				this.adsSwitchActive = true;
			} else {
				this.adsSwitchActive = false;
				this.userStore.currBusiness.analytics_ads_id = null;
				this.userStore.currBusiness.analytics_ads_purchase_label = null;
			}
		},
		orderCustomerConfSwitched(active) {
			if(this.userStore.currBusiness) {
				this.userStore.currBusiness.customer_completable_order = active ? 1 : 0;
			}
		},
		orderCustomerConfRadioChosen(value) {
			if(this.userStore.currBusiness && this.userStore.currBusiness.customer_completable_order !== 0) {
				if(value === 0) {
					this.userStore.currBusiness.customer_completable_order = 1;
				} else if(value === 1){
					this.userStore.currBusiness.customer_completable_order = 2;
				}
			}
		},
		selectedCustomerOrderModeIndex() {
			if(this.userStore.currBusiness) {
				if(this.userStore.currBusiness.customer_completable_order === 1) {
					return 0;
				} else if(this.userStore.currBusiness.customer_completable_order === 2) {
					return 1;
				}
			}
			return 0;
		},
		changedValueMinOrder(value) {
			if(this.userStore.currBusiness && value) {
				this.userStore.currBusiness.min_order = this.currencyStore.actualToDbValue(value);
			}
		},
		changedValuePreparationTime(value) {
			if(this.userStore.currBusiness) {
				this.userStore.currBusiness.preparation_time = value;
			}
		},
		changedValueBufferTime(value) {
			if(this.userStore.currBusiness) {
				this.userStore.currBusiness.buffer_time = value;
			}
		},
		toggleBufferTime(open) {
			if(open) {
				this.userStore.currBusiness.buffer_time = 300;
				this.userStore.currBusiness.buffer_customers = false;
			} else {
				this.userStore.currBusiness.buffer_time = null;
				this.userStore.currBusiness.buffer_customers = false;
			}
		},
		saveOrderFeatures() {

			let self = this;
			this.userStore.updateBusiness({
				hide_notes: this.userStore.currBusiness.hide_notes,
				preparation_time: this.userStore.currBusiness.preparation_time,
				min_order: this.userStore.currBusiness.min_order,
				buffer_time: this.userStore.currBusiness.buffer_time,
				buffer_customers: this.userStore.currBusiness.buffer_customers,
				queue_active_menu: this.userStore.currBusiness.queue_active_menu,
				queue_active_summary: this.userStore.currBusiness.queue_active_summary,
			}, function (success) {
				if(success) {
					self.showNotification("generic-success");
				} else {
					self.showNotification("generic-fail");
				}
			})
		},
        saveMarketing() {
			let self = this;
			let link_feedbacks = null;
			let custom_terms = null;
			let custom_privacy = null;

			if(this.userStore.currBusiness.link_feedbacks){
				if(validateLink(this.userStore.currBusiness.link_feedbacks) && this.userStore.currBusiness.link_feedbacks.startsWith("https")) {
					link_feedbacks = this.userStore.currBusiness.link_feedbacks;
				}else {
					return this.showNotification('invalid-url-custom', ['"'+this.getString("link_feedbacks_title")+'"']);
				}
			}

			if(this.userStore.currBusiness.custom_terms){
				if(validateLink(this.userStore.currBusiness.custom_terms) && this.userStore.currBusiness.custom_terms.startsWith("https")) {
					custom_terms = this.userStore.currBusiness.custom_terms;
				}else {
					return this.showNotification('invalid-url-custom', ['"'+this.getString("custom_terms")+'"']);
				}
			}

			if(this.userStore.currBusiness.custom_privacy){
				if(validateLink(this.userStore.currBusiness.custom_privacy) && this.userStore.currBusiness.custom_privacy.startsWith("https")) {
					custom_privacy = this.userStore.currBusiness.custom_privacy;
				}else {
					return this.showNotification('invalid-url-custom', ['"'+this.getString("custom_privacy")+'"']);
				}
			}

			if(this.userStore.currBusiness.analytics_ga4_id){
				const ga4Pattern = /^G-[A-Z0-9]+$/;
				if(!ga4Pattern.test(this.userStore.currBusiness.analytics_ga4_id)) {
					return this.showNotification('invalid-analytics-field', ['"'+this.getString("ga4_tag_id")+'"']);
				}
			}

			// Meta requires both values to be set together
			if((this.userStore.currBusiness.analytics_meta_pixel_id && !this.userStore.currBusiness.analytics_meta_conversions_key) ||
			   (!this.userStore.currBusiness.analytics_meta_pixel_id && this.userStore.currBusiness.analytics_meta_conversions_key)) {
				return this.showNotification('invalid-analytics-field', ['"Meta (Facebook Pixel)"']);
			}

			if(this.userStore.currBusiness.analytics_meta_pixel_id){
				const metaPixelPattern = /^[0-9]+$/;
				if(!metaPixelPattern.test(this.userStore.currBusiness.analytics_meta_pixel_id)) {
					return this.showNotification('invalid-analytics-field', ['"'+this.getString("meta_pixel_id")+'"']);
				}
			}

			if(this.userStore.currBusiness.analytics_meta_conversions_key){
				const metaConversionsKeyPattern = /^[a-zA-Z0-9]+$/;
				if(this.userStore.currBusiness.analytics_meta_conversions_key.length < 10 || !metaConversionsKeyPattern.test(this.userStore.currBusiness.analytics_meta_conversions_key)) {
					return this.showNotification('invalid-analytics-field', ['"'+this.getString("meta_conversions_key")+'"']);
				}
			}

			// TikTok requires both values to be set together
			if((this.userStore.currBusiness.analytics_tiktok_pixel_id && !this.userStore.currBusiness.analytics_tiktok_access_token) ||
			   (!this.userStore.currBusiness.analytics_tiktok_pixel_id && this.userStore.currBusiness.analytics_tiktok_access_token)) {
				return this.showNotification('invalid-analytics-field', ['"TikTok Pixel"']);
			}

			if(this.userStore.currBusiness.analytics_tiktok_pixel_id){
				const tiktokPixelPattern = /^[a-zA-Z0-9]+$/;
				if(!tiktokPixelPattern.test(this.userStore.currBusiness.analytics_tiktok_pixel_id)) {
					return this.showNotification('invalid-analytics-field', ['"'+this.getString("tiktok_pixel_id")+'"']);
				}
			}

			if(this.userStore.currBusiness.analytics_tiktok_access_token){
				const tiktokAccessTokenPattern = /^[a-zA-Z0-9]+$/;
				if(this.userStore.currBusiness.analytics_tiktok_access_token.length < 10 || !tiktokAccessTokenPattern.test(this.userStore.currBusiness.analytics_tiktok_access_token)) {
					return this.showNotification('invalid-analytics-field', ['"'+this.getString("tiktok_access_token")+'"']);
				}
			}

			// Google Ads requires both values to be set together
			if((this.userStore.currBusiness.analytics_ads_id && !this.userStore.currBusiness.analytics_ads_purchase_label) ||
			   (!this.userStore.currBusiness.analytics_ads_id && this.userStore.currBusiness.analytics_ads_purchase_label)) {
				return this.showNotification('invalid-analytics-field', ['"Google Ads"']);
			}

			if(this.userStore.currBusiness.analytics_ads_id){
				const adsIdPattern = /^[a-zA-Z0-9_]+$/;
				if(!adsIdPattern.test(this.userStore.currBusiness.analytics_ads_id)) {
					return this.showNotification('invalid-analytics-field', ['"'+this.getString("ads_id")+'"']);
				}
			}

			if(this.userStore.currBusiness.analytics_ads_purchase_label){
				const adsPurchaseLabelPattern = /^[a-zA-Z0-9_]+$/;
				if(!adsPurchaseLabelPattern.test(this.userStore.currBusiness.analytics_ads_purchase_label)) {
					return this.showNotification('invalid-analytics-field', ['"'+this.getString("ads_purchase_label")+'"']);
				}
			}

			const updateBusinessPromise = new Promise((resolve, reject) => {
				this.userStore.updateBusiness({
					coupons: this.userStore.currBusiness.coupons,
					disable_feedbacks: this.userStore.currBusiness.disable_feedbacks,
					private_feedbacks: !this.userStore.currBusiness.disable_feedbacks && this.userStore.currBusiness.private_feedbacks,
					force_privacy: this.userStore.currBusiness.force_privacy,
					cross_selling: this.userStore.currBusiness.cross_selling,
					cross_selling_popup: this.userStore.currBusiness.cross_selling_popup,
					enabled_box_email_cash: this.userStore.currBusiness.enabled_box_email_cash,
					custom_terms: custom_terms,
					custom_privacy: custom_privacy,
					link_feedbacks: link_feedbacks
				}, function (success) {
					if(success) {
						resolve();
					} else {
						reject();
					}
				});
			});

			const updateByoAnalyticsPromise = new Promise((resolve, reject) => {
				API.init().updateByoAnalytics(
					this.userStore.currBusiness.business_id,
					this.userStore.currBusiness.analytics_ga4_id,
					this.userStore.currBusiness.analytics_meta_pixel_id,
					this.userStore.currBusiness.analytics_meta_conversions_key,
					this.userStore.currBusiness.analytics_tiktok_pixel_id,
					this.userStore.currBusiness.analytics_tiktok_access_token,
					this.userStore.currBusiness.analytics_ads_id,
					this.userStore.currBusiness.analytics_ads_purchase_label,
					function (response) {
						if(response && response.result === "OK") {
							resolve();
						} else {
							reject();
						}
					}
				);
			});

			Promise.all([updateBusinessPromise, updateByoAnalyticsPromise])
				.then(() => {
					self.showNotification("generic-success");
				})
				.catch(() => {
					self.showNotification("generic-fail");
				});
		},
		saveOrderCompletion() {
			let self = this;
			this.userStore.updateBusiness({
				show_order_qr: this.userStore.currBusiness.show_order_qr,
				customer_completable_order: this.userStore.currBusiness.customer_completable_order,
				autocomplete_old_orders: this.userStore.currBusiness.autocomplete_old_orders,
				allow_request_invoice: this.userStore.currBusiness.allow_request_invoice,
				receipt_background_color: this.userStore.currBusiness.receipt_background_color ? this.userStore.currBusiness.receipt_background_color.replace("#", "") : null,
				receipt_custom_instructions: this.userStore.currBusiness.receipt_custom_instructions,
				receipt_ticket_image: this.userStore.currBusiness.receipt_ticket_image,
				receipt_ticket_color1: this.userStore.currBusiness.receipt_ticket_color1,
				receipt_ticket_color2: this.userStore.currBusiness.receipt_ticket_color2,
				receipt_ticket_color3: this.userStore.currBusiness.receipt_ticket_color3,
			}, function (success) {
				if(success) {
					self.showNotification("generic-success");
				} else {
					self.showNotification("generic-fail");
				}
			})
		},
	},
	mounted() {
		// Initialize switch states based on existing data
		this.ga4SwitchActive = this.ga4Active;
		this.metaSwitchActive = this.metaActive;
		this.tiktokSwitchActive = this.tiktokActive;
		this.adsSwitchActive = this.adsActive;

		if (!this.userStore.bannersData?.has_qr_orders) {
			this.userStore.fetchBannersData('has_qr_orders');
		}
	},
	watch: {
		'userStore.currBusinessId': function (newVal, oldVal) {
			if (newVal !== oldVal) {
				this.ga4SwitchActive = this.ga4Active;
				this.metaSwitchActive = this.metaActive;
				this.tiktokSwitchActive = this.tiktokActive;
				this.adsSwitchActive = this.adsActive;
				if(!!newVal) {
					this.userStore.fetchBannersData('has_qr_orders');
				}
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.features-settings {
	.extra-text {
		p {
			font-size: 14px;
			color: #9B9B9B;
		}
	}

	.quantity-container {
		gap: 8px;
	}

	.ml-auto {
		margin-left: auto;
	}

	.colors-gradient-container {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.colors-gradient {
			display: flex;
			gap: 8px;
		}

	}

	:deep(.card-container .card-body) {
		padding: 0;
		& > .list-container {
			.list-item:first-child::before {
				display: none;
			}

			.list-item:last-child::after {
				display: none;
			}

		}
	}

	.list-slot-container {
		:deep(.dropdown-content) {
			padding: 0;
		}
	}

	.completable-options {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		gap: 8px;

		.container-radio-group {
			flex-shrink: 0;
			margin-left: auto;
		}

	}

	.card-margin {
		margin-top: var(--main-padding);
	}

	.card-info-banner {
		margin-bottom: 40px;
		.card-info-banner-title {
			width: 100%;
			height: fit-content;
			display: flex;
			align-items: flex-start;
			justify-content: flex-start;
			flex-direction: column;
			color: var(--color-txt-white);
			max-width: 400px;
			text-align: left;
			.align-text {
				display:flex;
				flex-direction: column;
			}
			&.divider {
				padding-bottom: 20px;
				border-bottom: 1px solid rgba(255, 255, 255, 0.5);
				width: 100%;
				margin-bottom: 20px;
			}
			h2 {
				font-size: 22px;
				display: inline-block;
				color: var(--color-txt-white);
				@media (max-width: 550px) {
					font-size: 20px;
					line-height: normal;
				}
			}
			p {
				font-size: 16px;
				line-height: 22px;
				color: var(--color-txt-white);
				margin-top: 10px;
				@media (max-width: 550px) {
					font-size: 14px;
					line-height: 20px;
				}
				&.br {
					margin-top: 15px!important;
				}
			}
			.card-info-banner-button {
				margin-top: 20px;
			}
		}
		&:deep(.slashed-card-container) {
			padding: 15px 20px;
			background: linear-gradient(204deg, var(--color-danger) 10%, rgb(47, 36, 209) 90%);
			height: 100%;
			gap: 40px;
			position: relative;
			&:before {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: linear-gradient(344deg, #00B96C -10%, rgba(0, 185, 108, 0) 60%);
				pointer-events: none;
				z-index: 1;
				border-radius: 13px;
				@media (max-width: 550px) {
					background: linear-gradient(118deg, #00B96C -10%, rgba(0, 185, 108, 0) 70%);
				}
			}
			.slashed-left {
				width: calc(65% - 20px);
				justify-content: flex-start;
				padding: 0;
				overflow: unset;
				border-radius: 0;
				flex-direction: column;
				z-index: 2;

				.card-info-banner-title {
					width: 100%;
					max-width: unset;
				}

				@media (max-width: 550px) {
					width: 100%;
					padding: 0;
					min-height: unset;
					.card-info-banner-title {
						width: 100%;
						max-width: unset;
						padding: 0;
					}
				}
			}
			.slashed-right {
				z-index: 2;
				width: calc(35% - 20px);
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 0;
				@media (max-width: 550px) {
					width: 100%;
					padding: 0;
				}
			}
			@media (max-width: 550px) {
				flex-direction: column-reverse;
				gap: 0;
			}
		}
		.wrapper-img {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			picture {
				img {
					width: 100%;
					height: 100%;
					max-height: 250px;
					object-fit: contain;
					@media (max-width: 550px) {
						max-height: 200px;
					}
				}
			}
		}
		.icon-link {
			min-height: 40px;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			cursor: pointer;
			gap: 7px;
			margin-top: 8px;
			opacity: .9;
			transition: opacity .2s $transition;
			padding-right: 20px;
			font-size: 14px;
			line-height: 14px;
			font-weight: 400;
			color: var(--color-secondary);
			font-style: italic;
			width: calc(100% - 20px);
			&:after {
				display: none;
			}
			.wrapper-icon {
				margin-top: 2px;
				width: 12px;
				height: 12px;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: transform .2s $transition;
				transform: translateX(0);
				img {
					width: 100%;
					height: 100%;
					max-height: 180px;
					object-fit: contain;
				}
			}
			&:hover {
				opacity: 1;
				.wrapper-icon {
					transform: translateX(2px);
				}
			}
		}
	}
	.list-item-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 100%;
		gap: 8px;

		.list-item-title {
			font-size: 16px;

			@media (max-width: 560px) {
				font-size: 14px;
			}
		}

		.right-item {
			margin-left: auto;
		}
	}

}
</style>